import { EntityId } from '@reduxjs/toolkit';
import { createOptionBindings } from '@ff-os/pdp-shared-redux/slices/sceneSlice';
import { PhotoPrintsSceneOptions } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsSceneOptions';
import { PhotoPrintsPdpState } from '../store';

const optionsBindings = createOptionBindings<PhotoPrintsSceneOptions, PhotoPrintsPdpState>();
const adapterSelector =  optionsBindings.createEntityOptionSelectors(s => s.borders);

export const selectAllBorderIds = (state: PhotoPrintsPdpState) => {
    if (state.scene.options?.borders === undefined) {
        return [];
    } else {
        return adapterSelector.selectIds(state) as string[];
    }
};

export const selectBorderById = (state: PhotoPrintsPdpState, id: EntityId | undefined) => {
    if (state.scene.options?.borders === undefined || !id) {
        return null;
    } else {
        return adapterSelector.selectById(state, id);
    }
};

export const selectAllBorders = (state: PhotoPrintsPdpState) => {
    if (state.scene.options?.borders === undefined) {
        return [];
    } else {
        return adapterSelector.selectAll(state);
    }
};